import type { ElementType, ReactNode } from 'react';
import React from 'react';
import { StyledCenter } from './styles';

interface CenterProps {
  children?: ReactNode;
  htmlTag?: ElementType;
  className?: string;
}

const Center: React.FC<CenterProps> = ({ children = null, htmlTag: CustomTag = 'div', className = undefined }) => {
  return (
    <StyledCenter as={CustomTag} className={className}>
      {children}
    </StyledCenter>
  );
};

export default Center;
